/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * Barva pozadí. Na barvy se aplikuje téma aplikace.
 * Úpravy je nutné promítnout i do souboru constants.less.
 */
export enum ButtonBackgroundColor {

    /*----- Obecné -----*/
    default = "default",
    inherit = "inherit",

    /*----- Pozadí -----*/
    headerBgWithoutBlur = "header-bg-without-blur",
    buttonPrimary = "button-primary",
    buttonPrimaryColor = "button-primary-color",
    transparent = "transparent",

    /*----- Odstíny šedi -----*/
    /* black-white (výchozí) */
    blackWhite = "black-white",

    /* černá-černá */
    blackPrimaryFixed = "black-primary-fixed",
    blackSecondaryFixed = "black-secondary-fixed",
    blackDisabledFixed = "black-secondary-fixed",

    /* bílá-bílá */
    whitePrimaryFixed = "white-primary-fixed",
    whiteSecondaryFixed = "white-secondary-fixed",
    whiteDisabledFixed = "white-secondary-fixed",

    /* bílá-černá */
    whiteBlack = "white-black",

    /*----- Branding -----*/

    /* tmavá-světlá (výchozí) */
    colorPrimary = "color-primary",
    colorSecondary = "color-secondary",

    /* tmavá-tmavá */
    colorPrimaryDarkFixed = "color-primary-dark-fixed",
    colorSecondaryDarkFixed = "color-secondary-dark-fixed",
    blackFixed = "black-fixed",

    /* světlá-světlá */
    colorPrimaryLightFixed = "color-primary-light-fixed",
    colorSecondaryLightFixed = "color-secondary-light-fixed",
    whiteFixed = "white-fixed",

    /*----- Status -----*/

    /* Success */
    colorSuccess = "color-success",

    /* Information */
    colorInformation = "color-information",

    /* Warning */
    colorWarning = "color-warning",

    /* Error */
    colorError = "color-error",
}

/**
 * Určuje variantu stylů tlačítka
 */
export enum ButtonThemeVariant {
    /**
     * Příznak, zda má tlačítko používat styly třídy value-picker.
     * Tato třída obsahuje volání less funkce ecButton (styly pro tlačítka dědící z editable controlu).
     * Příznak zároveň přepíná styly na základě stavů, které jsou do ButtonProvideru předávány. Podporovány jsou následující stavy:
     * - enabled - styly povoleného tlačítka
     * - disabled - styly zakázaného tlačítka
     * - invalid - styly nevalidního stavu tlačítko
     */
    valuePicker = "value-picker",
    /** Styl tlačítka pro dropdown */
    dropdown = "dropdown",
    avatar = "avatar",
    default = "default",
}
